<template>
    <v-card>
        <v-card-title>
            Danh sách người thân
        </v-card-title>
        <v-card-text>
            <v-data-table :items="families" :headers="familyHeaders">
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'TabFamily',
    props: {
        families: Array,
        familyHeaders: Array
    }
}
</script>
